var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / maps / pin-round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8462 18.2554L12.75 19.2126L11.6538 18.2554C7.73842 14.8366 5.75 11.8112 5.75 9C5.75 5.02141 8.85349 2 12.75 2C16.6465 2 19.75 5.02141 19.75 9C19.75 11.8112 17.7616 14.8366 13.8462 18.2554ZM6.43555 14.8034C6.84614 15.3656 7.30352 15.9373 7.80748 16.519C5.94525 16.9384 4.75 17.5337 4.75 18C4.75 18.807 8.32914 20 12.75 20C17.1709 20 20.75 18.807 20.75 18C20.75 17.5337 19.5547 16.9384 17.6925 16.519C18.1965 15.9373 18.6539 15.3656 19.0644 14.8034C21.3133 15.4858 22.75 16.5804 22.75 18C22.75 20.5068 18.2703 22 12.75 22C7.22973 22 2.75 20.5068 2.75 18C2.75 16.5804 4.18674 15.4858 6.43555 14.8034ZM12.75 4C15.5538 4 17.75 6.13816 17.75 9C17.75 11.047 16.1227 13.5659 12.75 16.556C9.37733 13.5659 7.75 11.047 7.75 9C7.75 6.13816 9.94624 4 12.75 4ZM12.75 6C14.4069 6 15.75 7.34315 15.75 9C15.75 10.6569 14.4069 12 12.75 12C11.0931 12 9.75 10.6569 9.75 9C9.75 7.34315 11.0931 6 12.75 6ZM11.75 9C11.75 8.44772 12.1977 8 12.75 8C13.3023 8 13.75 8.44772 13.75 9C13.75 9.55228 13.3023 10 12.75 10C12.1977 10 11.75 9.55228 11.75 9Z",
    fill: "#B3B2B2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinRound);
export default __webpack_public_path__ + "static/media/pin-round.281aa02a7a00c702cbeb18cfdf5024cb.svg";
export { ForwardRef as ReactComponent };